import * as React from 'react';
import * as queryString from 'query-string';
import { Props } from 'react';
import { connect, Dispatch } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import { AppState } from '../../../reducers';

import { setUserIdAction, setChannelIdAction, setUserLangAction } from '../../../actions/user';

import { HomeView } from './HomeView';
import i18next from 'i18next';
import { HomeButtonView } from '../../Buttons/HomeButton/HomeButtonView';

interface RouteProps extends RouteComponentProps<{}> {
    history: any;
}

interface HomeTelemedicineContainerProps extends Props<HomeTelemedicineContainer> {
    channelId: string;
    lang: string;
}

interface HomeTelemedicineContainerDispatch extends Props<HomeTelemedicineContainer> {
    setUserId: (userId: string) => any;
    setChannelId: (channelId: string) => any;
    setLang: (lang: string) => any;
}

function mapProps(state: AppState, props: HomeTelemedicineContainerProps): HomeTelemedicineContainerProps {
    return {
        channelId: state.userState.channelId,
        lang: state.userState.lang
    };
}

function mapDispatch(dispatch: Dispatch<any>) {
    return {
        setUserId: (userId: string) => dispatch(setUserIdAction(userId)),
        setChannelId: (channelId: string) => dispatch(setChannelIdAction(channelId)),
        setLang: (lang: string) => dispatch(setUserLangAction(lang))
    };
}

type AllProps = HomeTelemedicineContainerProps & HomeTelemedicineContainerDispatch & RouteProps;

class HomeTelemedicineContainer extends React.Component<AllProps> {
    async componentDidMount() {
        const { history, setUserId, setChannelId, setLang, lang } = this.props;
        if (history.location.search) {
            const params = queryString.parse(history.location.search);
            const userId = params.user_id;
            const channelId = params.channel_id;
            const language = params.lang;
            if (!lang) {
                setLang(language || 'ru');
            }
            if (language && language !== lang && i18next.languages.some(it => it === lang)) {
                setLang(language);
                await i18next.changeLanguage(language);
            }

            if (userId) {
                setUserId(userId);
            }
            if (channelId) {
                setChannelId(channelId);
            }
        }
    }

    render() {
        document.title = i18next.t('telemedicine');
        const {channelId, history} = this.props;
        return (
            <div className='container'>
                <HomeButtonView
                    clickHome={() => history.push(`/services?user_id=${encodeURIComponent(localStorage.KON_USER_ID)}&channel_id=${localStorage.KON_CHANNEL_ID}&lang=${localStorage.KON_LANG}&tariff_id=${localStorage.KON_TARIFF_ID}`)}
                />
                <HomeView channelId={channelId} />
            </div>
        );
    }
}

export default withRouter(connect(mapProps, mapDispatch)(HomeTelemedicineContainer));



// WEBPACK FOOTER //
// ./src/components/Telemedicine/Home/HomeTelemedicineContainer.tsx